<template>
  <v-select
    v-model="select"
    :items="patternItems"
    item-text="text"
    item-value="value"
    label="Select"
    persistent-hint
    single-line
    hide-details=""
    outlined
    dense
  ></v-select>
</template>

<script>
export default {
  name: "RepeatTypeSelect",
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
  },
  computed: {
    select: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    patternItems() {
      return [
        // { text: "Day", value: "day" },
        // { text: "Week", value: "week" },
        { text: this.$t('lblMonth'), value: "month" },
        // { text: "Year", value: "year" },
      ];
    },
  },
};
</script>

<style>
</style>